import * as actionTypes from '../actions/allActionList';

const initialState = {
  fetchingAssignmentsStarted: false,
  fetchingAssignmentsDone: false,
  assignments: [],
  assignmentCommentsInfo: [], // contains data returned
  individualAssignmentDetails: null,
  individualAssignmentComments: null,

  creatingAssignmentStarted: false,
  creatingAssignmentDone: false,

  /* Sending assignment comments helper properties */
  sendingStarted: false,
  sendingDone: false,
  failed: false,

  /* States for fetching submissions */
  submissions: [],
  studentsSubmissionsInfo: [],
  singleSubmission: null,
  startedFetchingSubmissions: false,
  doneFetchingSubmissions: false,
  errorFetchingSubmissions: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STARTED_FETCHING_ASSIGNMENTS:
      return {
        ...state,
        fetchingAssignmentsStarted: true,
      };
    case actionTypes.INITIALIZE_ASSIGNMENTS:
      return {
        ...state,
        assignments: action.assignments,
        fetchingAssignmentsStarted: false,
        fetchingAssignmentsDone: true,
      };
    case actionTypes.STARTED_CREATING_ASSIGNMENT:
      return {
        ...state,
        creatingAssignmentDone: false,
        creatingAssignmentStarted: true,
      };
    case actionTypes.FAILED_CREATING_ASSIGNMENT:
      return {
        ...state,
        creatingAssignmentDone: true,
        creatingAssignmentStarted: false,
      };
    case actionTypes.FINISHED_CREATING_ASSIGNMENT:
      return {
        ...state,
        creatingAssignmentDone: true,
        creatingAssignmentStarted: false,
        assignments: action.assignments,
      };
    case actionTypes.RESET_CREATING_ASSIGNMENT_DATA:
      return {
        ...state,
        creatingAssignmentStarted: false,
        creatingAssignmentDone: false,
      };
    case actionTypes.SET_INIDIVIDUAL_ASSIGNMENT_DATA:
      return {
        ...state,
      };
    case actionTypes.RESET_INIDIVIDUAL_ASSIGNMENT_DATA:
      return {
        ...state,
      };
    case actionTypes.GOTTEN_ASSIGNMENT_COMMENTS:
      return {
        ...state,
        assignmentCommentsInfo: action.commentsInfo,
        individualAssignmentComments: action.comments,
      };
    case actionTypes.FAILED_TO_GET_ASSIGNMENT_COMMENTS:
      return {
        ...state,
        individualAssignmentComments: action.comments,
      };
    case actionTypes.STARTED_SENDING_ASSIGNMENT_COMMENT:
      return {
        ...state,
        sendingStarted: true,
        sendingDone: false,
        failed: false,
      };
    case actionTypes.SENT_ASSIGNMENT_COMMENT:
      return {
        ...state,
        individualAssignmentComments: action.comments,
        assignmentCommentsInfo: action.commentsInfo,
        sendingStarted: false,
        sendingDone: true,
        failed: false,
      };
    case actionTypes.FAILED_TO_SEND_ASSIGNMENT_COMMENT:
      return {
        ...state,
        sendingStarted: false,
        sendingDone: true,
        failed: true,
      };
    case actionTypes.STARTED_FETCHING_SUBMISSIONS:
      return {
        ...state,
        startedFetchingSubmissions: true,
        doneFetchingSubmissions: false,
        errorFetchingSubmissions: false,
      };
    case actionTypes.FETCHED_SUBMISSIONS_EDUCATOR:
      return {
        ...state,
        startedFetchingSubmissions: false,
        doneFetchingSubmissions: true,
        submissions: action.submissions,
        studentsSubmissionsInfo: action.studentsInfo,
      };
    case actionTypes.FETCHED_SUBMISSION_STUDENT:
      return {
        ...state,
        startedFetchingSubmissions: false,
        doneFetchingSubmissions: true,
        singleSubmission: action.submission,
      };
    case actionTypes.FAILED_TO_FETCH_SUBMISSIONS:
      return {
        ...state,
        startedFetchingSubmissions: false,
        doneFetchingSubmissions: true,
        errorFetchingSubmissions: true,
      };
    case actionTypes.FINISHED_SUBMITTING_ASSIGNMENT:
      return {
        ...state,
        singleSubmission: action.submission,
      };
    case actionTypes.RESET_SINGLE_SUBMISSION:
      return {
        ...state,
        singleSubmission: null,
      };
    case actionTypes.UPDATE_SUBMISSIONS:
      return {
        ...state,
        submissions: action.submissions,
      };
    default:
      return state;
  }
};

export default reducer;
